module.exports = __webpack_public_path__ + "img/img_18.b9a9a06e.jpg";